import axios from "axios";
import { useEffect, useState } from "react";

export const API = process.env.REACT_APP_BACKEND_URL + "/api";
export const DEFAULT_WHATSAPP = "393348361269";

export const buildWhatsAppLink = (number, message) =>
  `https://wa.me/${(number || DEFAULT_WHATSAPP).replace(/\D/g, "")}?text=${encodeURIComponent(message)}`;

let cachedNumber = null;

export function useWhatsAppNumber() {
  const [number, setNumber] = useState(cachedNumber || DEFAULT_WHATSAPP);
  useEffect(() => {
    if (cachedNumber) return;
    axios
      .get(`${API}/config`)
      .then(({ data }) => {
        cachedNumber = data.whatsapp_number;
        setNumber(data.whatsapp_number);
      })
      .catch(() => {});
  }, []);
  return number;
}
